import * as React from "react";
import "./address-list-type-icon.scss";
import {getAddressListTypes} from "./address-list-types";

export const AddressListTypeIcon = ({value, xdQaName=undefined}) => {
    const type = getAddressListTypes().find((type) => (
        type.value === value ||
        type.addressListTypes?.includes(value)
    ));
    return !type ? (
        value
    ) : (
        <img
            className="address-list-type-icon-9sw" src={type.icon}
            alt={value}
            xd-qa-type="icon"
            xd-qa-name={xdQaName+" "+type.label}
        />
    );
};